import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-arrow-right\"><path style=\"fill:currentColor;fill-opacity:1;stroke:none;color:#4d4d4d\" d=\"M7.707 3 7 3.707l6.125 6.125L14.293 11l-1.168 1.168L7 18.293l.707.707 6.125-6.125L15.707 11l-1.875-1.875L7.707 3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol